import { useEffect, useState } from "react";
import axios from "axios";
import { login, getAuthToken } from "../../auth/auth";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const classroomPassphrase = process.env.REACT_APP_CLASSROOM_KEY;
const hospitalPassphrase = process.env.REACT_APP_HOSPITAL_KEY;

const useAvatarVideos = () => {
  const [videos, setVideos] = useState({ idleVideo: "", talkVideo: "" });

  const determinePassphrase = () => {
    const currentURL = window.location.href;
    return currentURL.includes("classroom")
      ? classroomPassphrase
      : hospitalPassphrase;
  };

  const performLogin = async () => {
    try {
      const token = await login();
      return token;
    } catch (error) {
      console.error("Failed to login:", error);
      return null;
    }
  };

  const getAvatarVideoConfig = async (passphrase, language) => {
    const token = getAuthToken();
    const setLanguage = language === "en" ? "english" : "indonesian";

    try {
      const response = await axios.get(
        `${BASE_URL}/api/config/passphrase/${passphrase}/language/${setLanguage}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const storedId = sessionStorage.getItem("id");
      const matchingConfig = response.data.data.find(
        (item) => item.id.toString() === storedId
      );
      return matchingConfig ? matchingConfig.configId : null;
    } catch (error) {
      console.error("Error fetching avatar video config:", error);
      return null;
    }
  };

  const getAvatarHyperlink = async (configId) => {
    const token = getAuthToken();
    try {
      const response = await axios.get(
        `${BASE_URL}/api/config/id/${configId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const idleVideo = BASE_URL + response.data.data.avatar.idleHyperlink;
      const talkVideo = BASE_URL + response.data.data.avatar.talkingHyperlink;
      sessionStorage.setItem("idleVideo", idleVideo);
      return { idleVideo, talkVideo };
    } catch (error) {
      console.error("Error fetching avatar hyperlinks:", error);
      return { idleVideo: "", talkVideo: "" };
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = await performLogin();
      if (!token) return;

      const language = "en";
      const passphrase = determinePassphrase();
      const avatarVideoConfig = await getAvatarVideoConfig(
        passphrase,
        language
      );
      if (!avatarVideoConfig) return;

      const { idleVideo, talkVideo } = await getAvatarHyperlink(
        avatarVideoConfig
      );
      setVideos({ idleVideo, talkVideo });
    };

    fetchData();
  }, []);

  return videos;
};

export default useAvatarVideos;
